import { useSelector } from 'react-redux';
import { currencyRatesSelector } from '../../redux/reducers/common/common_reducers/currencyRates';
import { formatGel } from '../../hooks/common/usePaymentPlans';

const toUsd = (gel, rates) => {
    if (!rates || !rates.usd) return null;
    const usd = gel / rates.usd;
    return usd >= 10 ? Math.round(usd) : Math.round(usd * 10) / 10;
};

export const PlanPrice = ({ gel }) => {
    const rates = useSelector(currencyRatesSelector);
    const usd = toUsd(gel, rates);

    return (
        <>
            {formatGel(gel)}
            {usd ? <small className="plan-price__usd">≈ ${usd}</small> : null}
        </>
    );
};

export default PlanPrice;
